import { Header } from "../components/header/Header";
import FooterOne from "../components/footer/FooterOne";
import TermsText from "../components/content/TermsText";

const Terms = () => {
  return (
    <div>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
      </div>
      <TermsText />
      <FooterOne />
    </div>
  );
};

export default Terms;
